import destination from "@turf/destination";
import center from "@turf/center";
import { featureCollection, point, Units } from "@turf/helpers";
import bearing from "@turf/bearing";
import { distance, flip } from "@turf/turf";

export const recalculatePolygonPositionsBasedOnWidthAndHeight = (
  positions: [number, number][],
  height: number,
  width: number,
): [number, number][] => {
  const topLeft = point([positions[0][1], positions[0][0]]); // [lng, lat]
  const bottomLeft = point([positions[3][1], positions[3][0]]); // [lng, lat]
  const topRight = point([positions[1][1], positions[1][0]]); // [lng, lat]

  // Calculate the center of the image
  const _center = center(featureCollection([bottomLeft, topRight]));

  // Calculate the rotation angle (bearing) between topLeft and topRight
  const _bearing = bearing(topLeft, topRight) - 90;

  // Calculate the new positions based on the updated width and height
  const _width = width / 2;
  const _height = height / 2;

  const options = { units: "meters" as Units };

  const left = destination(_center, _width, -90 + _bearing, options);
  const right = destination(_center, _width, 90 + _bearing, options);

  const tL = flip(destination(left, _height, 0 + _bearing, options));
  const bL = flip(destination(left, _height, 180 + _bearing, options));
  const tR = flip(destination(right, _height, 0 + _bearing, options));
  const bR = flip(destination(right, _height, 180 + _bearing, options));

  return [
    tL.geometry.coordinates as [number, number],
    tR.geometry.coordinates as [number, number],
    bR.geometry.coordinates as [number, number],
    bL.geometry.coordinates as [number, number],
  ];
};

export const getDistance = (start: [number, number], end: [number, number]): number => {
  const startPt = flip(point(start));
  const endPt = flip(point(end));

  return distance(startPt, endPt, { units: "meters" as Units });
};
